import { Injectable } from '@angular/core';
import { PdfExportCertificatesVentusBaseService } from './pdf-export-certificates-ventus-base.service';

@Injectable()
export class PdfExportCertificatesVentusLevel1Service extends PdfExportCertificatesVentusBaseService {

  constructor(
  ) {
    super()
  }

  protected fillInApprovedCodes(): void {
    this.doc.setFont('helvetica', 'bold');

    this.doc.text('E1F', 84, 260);
    this.doc.text('E2F', 84, 275);
    this.doc.text('G1F', 84, 290);

    this.doc.setFont('helvetica', 'normal');
  }
}
